import * as React from "react";
import AppIcon from "../components/AppIcon";
import { useNavigate } from "react-router-dom";
import { useUser } from "../utils/AccountStore";

const Contact = () => {
    const navigate = useNavigate();
    const { user } = useUser();

    return (
        <div
            className="min-h-screen bg-cover bg-center bg-no-repeat bg-fixed"
            style={{
                backgroundImage: "url(/images/collectivebg-2.jpg)",
            }}
        >
            <div className="min-h-screen backdrop-blur-sm" style={{ backgroundColor: "rgba(241, 245, 248, 0.9)" }}>
                {/* Header Section */}
                <div className="pt-8 pb-6">
                    <div className="max-w-6xl mx-auto px-8">
                        <div className="flex items-center justify-between mb-6">
                            <button
                                onClick={() => navigate("/home")}
                                className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                                style={{ backgroundColor: "rgba(121, 153, 186, 0.9)" }}
                            >
                                <span className="text-white text-xl"><AppIcon kind="home" /></span>
                            </button>
                            <div className="text-center w-full">
                                <h1 className="text-2xl font-bold mb-2" style={{ color: "#013A51" }}>
                                    Contact Us
                                </h1>
                                <div className="w-24 h-1 mx-auto rounded-full" style={{ backgroundColor: "#DB1C7D" }}></div>
                            </div>
                            <div className="w-24"></div> {/* Spacer for centering */}
                        </div>
                    </div>
                </div>

                {/* Content Section */}
                <div className="px-8 pb-8">
                    <div className="max-w-4xl mx-auto space-y-8">
                        {/* Hero Section */}
                        <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg text-center" style={{ borderLeft: `4px solid #DB1C7D` }}>
                            <div className="mb-6">
                                <span className="text-6xl"><AppIcon kind="phone" /></span>
                            </div>
                            <h2 className="text-3xl font-bold mb-4" style={{ color: "#013A51" }}>
                                Get In Touch
                            </h2>
                            <p className="text-xl leading-relaxed" style={{ color: "#708372" }}>
                                We'd love to hear from you! Whether you're interested in becoming a vendor, have questions about our market, or just want to say hello, our team is here to help.
                            </p>
                        </div>

                        {/* Contact Team Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {/* San-Marie Vogel - Owner */}
                            <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-6 shadow-lg" style={{ borderLeft: `4px solid #DB1C7D` }}>
                                <div className="text-center mb-6">
                                    <div className="w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: "rgba(219, 28, 125, 0.1)" }}>
                                        <img src="/images/San-Marie.jpg" alt="San-Marie Vogel" className="w-16 h-16 rounded-full object-cover" />
                                    </div>
                                    <h3 className="text-2xl font-bold mb-2" style={{ color: "#013A51" }}>
                                        SAN-MARIE VOGEL
                                    </h3>
                                    <div className="inline-block px-4 py-1 rounded-full text-sm font-semibold text-white" style={{ backgroundColor: "#DB1C7D" }}>
                                        Owner
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    <div className="flex items-center gap-4 p-3 rounded-lg" style={{ backgroundColor: "rgba(241, 245, 248, 0.5)" }}>
                                        <div>
                                            <p className="text-sm font-medium" style={{ color: "#013A51" }}>
                                                Email
                                            </p>
                                            <a
                                                href="mailto:san-marie@thecollectivemarket.co.za"
                                                className="text-sm font-semibold transition-colors duration-200 hover:opacity-80 whitespace-nowrap"
                                                style={{ color: "#DB1C7D" }}
                                            >
                                                san-marie@thecollectivemarket.co.za
                                            </a>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-4 p-3 rounded-lg" style={{ backgroundColor: "rgba(241, 245, 248, 0.5)" }}>
                                        <div>
                                            <p className="text-sm font-medium" style={{ color: "#013A51" }}>
                                                Phone
                                            </p>
                                            <a href="tel:0828532667" className="font-semibold transition-colors duration-200 hover:opacity-80" style={{ color: "#708372" }}>
                                                082 853 2667
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Jolene Schoeman - Vendor Coordinator */}
                            <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-6 shadow-lg" style={{ borderLeft: `4px solid #7999BA` }}>
                                <div className="text-center mb-6">
                                    <div className="w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: "rgba(121, 153, 186, 0.1)" }}>
                                        <img src="/images/Jolene.jpg" alt="Jolene Schoeman" className="w-16 h-16 rounded-full object-cover" />
                                    </div>
                                    <h3 className="text-2xl font-bold mb-2" style={{ color: "#013A51" }}>
                                        JOLENE SCHOEMAN
                                    </h3>
                                    <div className="inline-block px-4 py-1 rounded-full text-sm font-semibold text-white" style={{ backgroundColor: "#7999BA" }}>
                                        Vendor Co-ordinator
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    <div className="flex items-center gap-4 p-3 rounded-lg" style={{ backgroundColor: "rgba(241, 245, 248, 0.5)" }}>
                                        <div>
                                            <p className="text-sm font-medium" style={{ color: "#013A51" }}>
                                                Email
                                            </p>
                                            <a
                                                href="mailto:vendor@thecollectivemarket.co.za"
                                                className="text-sm font-semibold transition-colors duration-200 hover:opacity-80"
                                                style={{ color: "#DB1C7D" }}
                                            >
                                                vendor@thecollectivemarket.co.za
                                            </a>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-4 p-3 rounded-lg" style={{ backgroundColor: "rgba(241, 245, 248, 0.5)" }}>
                                        <div>
                                            <p className="text-sm font-medium" style={{ color: "#013A51" }}>
                                                Phone
                                            </p>
                                            <a href="tel:0834443550" className="font-semibold transition-colors duration-200 hover:opacity-80" style={{ color: "#708372" }}>
                                                083 444 3550
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Reasons */}
                        <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg" style={{ borderLeft: `4px solid #708372` }}>
                            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: "#013A51" }}>
                                <AppIcon kind="comments" /> How Can We Help?
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                                <div className="text-center">
                                    <div className="mb-4">
                                        <span className="text-3xl"><AppIcon kind="store" /></span>
                                    </div>
                                    <h4 className="text-xl font-bold mb-3" style={{ color: "#013A51" }}>
                                        Vendor Applications
                                    </h4>
                                    <p className="text-base mb-3" style={{ color: "#8B6F4C" }}>
                                        Interested in joining our market? Contact Jolene for vendor applications and requirements.
                                    </p>
                                    <button
                                        onClick={() =>
                                            (window.location.href =
                                                "https://forms.zohopublic.com/thecreativecollective/form/CYCREATIVEYOU2026INTEREST/formperma/jy34hs-bdrwqkoUCdEl5apm6n4HIf6Xaq_4W9RwqKAs")
                                        }
                                        className="px-4 py-2 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1 text-white"
                                        style={{ backgroundColor: "rgba(121, 153, 186, 0.9)" }}
                                    >
                                        Apply Now
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Office Hours & Social */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {/* Follow Us */}
                            <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg" style={{ borderLeft: `4px solid #8B6F4C` }}>
                                <div className="text-center">
                                    <span className="text-4xl mb-4 block"><AppIcon kind="mobile" /></span>
                                    <h3 className="text-2xl font-bold mb-4" style={{ color: "#013A51" }}>
                                        Stay Connected
                                    </h3>
                                    <p className="text-lg mb-6" style={{ color: "#8B6F4C" }}>
                                        Follow us on social media for the latest updates, vendor spotlights, and event announcements.
                                    </p>
                                    <div className="flex justify-center gap-4">
                                        <button
                                            className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                                            style={{ backgroundColor: "rgba(219, 28, 125, 0.9)" }}
                                        >
                                            <span className="text-white text-xl"><AppIcon kind="facebook" /></span>
                                        </button>
                                        <button
                                            className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                                            style={{ backgroundColor: "rgba(121, 153, 186, 0.9)" }}
                                        >
                                            <span className="text-white text-xl"><AppIcon kind="instagram" /></span>
                                        </button>
                                        <button
                                            className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                                            style={{ backgroundColor: "rgba(112, 131, 114, 0.9)" }}
                                        >
                                            <span className="text-white text-xl"><AppIcon kind="twitter" /></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="bg-gradient-to-r from-pink-100 to-blue-100 bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg text-center" style={{ borderLeft: `4px solid #DB1C7D` }}>
                            <h3 className="text-2xl font-bold mb-4" style={{ color: "#013A51" }}>
                                Quick Actions
                            </h3>
                            <p className="text-lg mb-6" style={{ color: "#708372" }}>
                                Explore more of what The Collective has to offer
                            </p>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <button
                                    onClick={() => navigate("/about")}
                                    className="px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                                    style={{ backgroundColor: "rgba(121, 153, 186, 0.9)" }}
                                >
                                    ℹ️ About Us
                                </button>

                                <button
                                    onClick={() => navigate("/exhibitors")}
                                    className="px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                                    style={{ backgroundColor: "rgba(112, 131, 114, 0.9)" }}
                                >
                                    <AppIcon kind="store" /> Our Vendors
                                </button>

                                <button
                                    onClick={() => navigate("/floorPlans")}
                                    className="px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                                    style={{ backgroundColor: "rgba(1, 58, 81, 0.9)" }}
                                >
                                    <AppIcon kind="map" /> Event Map
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
